import React from 'react';
import { Link } from 'react-router-dom'; // Użyj Link zamiast useNavigate

const PolitykaPrywatnosci: React.FC = () => {

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">

        <Link 
          to="/"
          className="mb-6 inline-flex items-center text-blue-600 hover:text-blue-800 transition-colors duration-200"
        >
          <i className="fas fa-arrow-left mr-2"></i>
          Powrót do strony głównej
        </Link>

        <div className="bg-white rounded-2xl shadow-lg p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">
            Polityka plików cookies (Cookie Policy)
          </h1>
          
          <div className="mb-6 p-6 bg-blue-50 rounded-lg border border-blue-200">
            <h2 className="text-xl font-bold text-blue-900 mb-2">NOVA HLS – NOVA Witryny</h2>
            <p className="text-blue-800">
              ul. Stanisławowska 47, 54-611 Wrocław, Polska<br />
              NIP: 8943267784 | REGON: 54263627300000 | KRS: 0001191908
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Wprowadzenie</h2>
              <p className="text-gray-600 mb-4">
                Niniejsza Polityka plików cookies określa zasady wykorzystywania plików cookies oraz podobnych technologii przez firmę NOVA HLS – NOVA Witryny (zwaną dalej „NOVA HLS”, „my”, „nas”, „nasza firma”) w ramach serwisów internetowych prowadzonych przez nas lub na naszą rzecz.
              </p>
              <p className="text-gray-600">
                Korzystając z naszej strony internetowej, użytkownik wyraża zgodę na używanie plików cookies zgodnie z niniejszą Polityką, o ile ustawienia jego przeglądarki nie stanowią inaczej.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Czym są pliki cookies?</h2>
              <p className="text-gray-600 mb-4">
                Pliki cookies (tzw. „ciasteczka") to niewielkie pliki tekstowe zapisywane na urządzeniu końcowym użytkownika (komputerze, smartfonie, tablecie itp.) podczas przeglądania stron internetowych.
              </p>
              <p className="text-gray-600">
                Cookies pozwalają rozpoznać urządzenie użytkownika i wyświetlać stronę internetową w sposób dostosowany do jego preferencji.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Jakie pliki cookies wykorzystujemy?</h2>
              <p className="text-gray-600 mb-4">
                Na naszych stronach mogą być stosowane następujące rodzaje plików cookies:
              </p>
              
              <div className="mb-4">
                <h3 className="text-xl font-semibold text-gray-700 mb-2">a) Niezbędne (techniczne) cookies</h3>
                <p className="text-gray-600">
                  Umożliwiają prawidłowe działanie serwisu, np. utrzymanie sesji użytkownika, obsługę formularzy, zabezpieczenia, preferencje prywatności.
                  Bez tych plików strona może nie działać prawidłowo.
                </p>
              </div>

              <div className="mb-4">
                <h3 className="text-xl font-semibold text-gray-700 mb-2">b) Analityczne i statystyczne cookies</h3>
                <p className="text-gray-600">
                  Pozwalają nam analizować sposób korzystania z witryny (np. liczba odwiedzin, źródła ruchu, zachowania użytkowników), co pomaga ulepszać funkcjonalność i zawartość serwisu.
                  Stosujemy je tylko za zgodą użytkownika (np. Google Analytics, Plausible, Matomo itp.).
                </p>
              </div>

              <div className="mb-4">
                <h3 className="text-xl font-semibold text-gray-700 mb-2">c) Funkcjonalne cookies</h3>
                <p className="text-gray-600">
                  Zapamiętują wybrane przez użytkownika ustawienia i preferencje (np. język, rozmiar czcionki, wygląd strony), aby zapewnić spersonalizowane doświadczenie.
                </p>
              </div>

              <div className="mb-4">
                <h3 className="text-xl font-semibold text-gray-700 mb-2">d) Marketingowe cookies</h3>
                <p className="text-gray-600">
                  Używane do celów reklamowych — umożliwiają dostosowanie treści reklamowych do zainteresowań użytkownika (np. Facebook Pixel, Google Ads, LinkedIn Insight Tag).
                  Są aktywowane wyłącznie za zgodą użytkownika.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Okres przechowywania cookies</h2>
              <p className="text-gray-600 mb-2">
                <strong>Sesyjne cookies</strong> – usuwane automatycznie po zamknięciu przeglądarki.
              </p>
              <p className="text-gray-600">
                <strong>Stałe cookies</strong> – przechowywane przez określony czas lub do momentu ich usunięcia przez użytkownika (zazwyczaj od 1 dnia do 24 miesięcy, w zależności od ustawień i celu).
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Zarządzanie plikami cookies</h2>
              <p className="text-gray-600 mb-4">
                Użytkownik może w każdej chwili zmienić ustawienia dotyczące plików cookies:
              </p>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2">
                <li>poprzez ustawienia swojej przeglądarki internetowej (np. blokowanie, usuwanie plików cookies),</li>
                <li>lub za pomocą naszego narzędzia do zarządzania zgodą (okno zgody/cookie banner).</li>
              </ul>
              
              <p className="text-gray-600 mb-4">Przykładowe odnośniki do instrukcji:</p>
              <div className="grid md:grid-cols-2 gap-4 mb-4">
                <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">
                  Chrome
                </a>
                <a href="https://support.mozilla.org/pl/kb/blokowanie-ciasteczek" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">
                  Firefox
                </a>
                <a href="https://support.microsoft.com/pl-pl/microsoft-edge/usuwanie-plik%C3%B3w-cookie-w-programie-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">
                  Edge
                </a>
                <a href="https://support.apple.com/pl-pl/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">
                  Safari
                </a>
              </div>
              
              <p className="text-gray-600">
                Wyłączenie plików cookies może wpłynąć na niektóre funkcje strony internetowej.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">6. Narzędzia zewnętrzne i integracje</h2>
              <p className="text-gray-600 mb-4">
                W ramach naszej witryny możemy korzystać z zewnętrznych narzędzi analitycznych lub marketingowych, które mogą również zapisywać cookies na urządzeniu użytkownika, np.:
              </p>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2">
                <li>Google Analytics (administrator: Google Ireland Limited),</li>
                <li>Google Ads,</li>
                <li>Meta (Facebook) Pixel,</li>
                <li>LinkedIn Insight Tag,</li>
                <li>Hotjar lub inne narzędzia UX.</li>
              </ul>
              <p className="text-gray-600">
                Każde z tych narzędzi stosuje własną politykę prywatności oraz cookies.
                Zalecamy zapoznanie się z politykami tych dostawców, zanim użytkownik wyrazi zgodę na ich użycie.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">7. Podstawa prawna przetwarzania danych</h2>
              <p className="text-gray-600 mb-4">
                Podstawą prawną przetwarzania danych osobowych za pomocą cookies jest:
              </p>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2">
                <li>art. 6 ust. 1 lit. f RODO (prawnie uzasadniony interes administratora) – dla cookies niezbędnych,</li>
                <li>art. 6 ust. 1 lit. a RODO (zgoda użytkownika) – dla cookies analitycznych, funkcjonalnych i marketingowych.</li>
              </ul>
              <p className="text-gray-600">
                Użytkownik ma prawo w każdej chwili wycofać swoją zgodę, bez wpływu na zgodność z prawem przetwarzania przed jej cofnięciem.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">8. Administrator danych</h2>
              <p className="text-gray-600 mb-4">
                Administratorem danych osobowych zbieranych za pomocą plików cookies jest:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700 font-semibold">NOVA HLS – NOVA Witryny</p>
                <p className="text-gray-600">ul. Stanisławowska 47, 54-611 Wrocław, Polska</p>
                <p className="text-gray-600">E-mail: witryny@novahls.pl</p>
                <p className="text-gray-600">Tel.: +48 727 149 151</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">9. Zmiany w Polityce cookies</h2>
              <p className="text-gray-600 mb-4">
                Zastrzegamy sobie prawo do wprowadzania zmian w niniejszej Polityce w dowolnym czasie.
                Wszelkie aktualizacje będą publikowane na naszej stronie internetowej wraz z nową datą obowiązywania.
              </p>
            </section>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mt-8">
              <p className="text-blue-800 text-sm">
                <strong>Data ostatniej aktualizacji:</strong> 4 października 2025 r.
              </p>
              <p className="text-blue-800 text-sm mt-2">
                © NOVA HLS – NOVA Witryny. Wszelkie prawa zastrzeżone.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolitykaPrywatnosci;